import {
    AgGridFilterModel,
    AgGridSortModel,
    FilterOption,
    SortOption
} from '@tassat/common-definitions';
import moment from 'moment';

export const createFilterModel = (filterModel: AgGridFilterModel, selectedOption: FilterOption): AgGridFilterModel => {
    if (selectedOption.colId === 'clear') {
        selectedOption = null;
    }

    return {
        ...filterModel,
        currentModel: selectedOption
    };
};

export const createSortModel = (sortModel: AgGridSortModel, selectedOption: SortOption): AgGridSortModel => {
    let model = sortModel && sortModel.currentModel;

    if (selectedOption.colId === 'clear') {
        model = null;
    } else if (model && model.colId === selectedOption.colId) {
        if (model.sort === 'asc') {
            model.sort = 'desc';
        } else {
            model.sort = 'asc';
        }
    } else {
        model = {
            colId: selectedOption.colId,
            sort: 'asc'
        };
    }

    return {
        ...sortModel,
        currentModel: model
    };
};

export const getCsvExportParams = (fileName, opts?: {
    formattingCallback?: (cell: any) => any;
    headerFormattingCallback?: (cell: any) => any;
    columnKeys?: string[];
}) => {
    return {
        allColumns: !opts.columnKeys,
        suppressQuotes: false,
        columnKeys: opts.columnKeys,
        columnSeparator: ',',
        fileName: fileName,
        processCellCallback: opts.formattingCallback || null,
        processHeaderCallback: opts.headerFormattingCallback || null
    };
};

export const highlightLockedRow = (params, lockField: string) => {
    let locked = false;
    if (lockField.includes('.')) {
        locked = params.data;
        lockField.split('.')
            .forEach(field => {
                locked = locked[field];
            });
    } else {
        locked = params.data[lockField];
    }

    if (locked) {
        return 'lockedRow';
    }
};

export const convertDateFilterToTime = (timeFrame: string) => {
    switch (timeFrame) {
        case '1d':
            return moment()
                .subtract(1, 'day')
                .format('x');
        case '1w':
            return moment()
                .subtract(1, 'week')
                .format('x');
        case '1m':
            return moment()
                .subtract(1, 'month')
                .format('x');
        case '45d':
            return moment()
                .subtract(45, 'day')
                .format('x');
        case '3m':
            return moment()
                .subtract(3, 'month')
                .format('x');
        case '6m':
            return moment()
                .subtract(6, 'month')
                .format('x');
        case '1y':
            return moment()
                .subtract(1, 'year')
                .format('x');
        case '18m':
            return moment()
                .subtract(18, 'month')
                .format('x');
        case 'YTD':
            return new Date(new Date()
                .getFullYear(), 0, 1)
                .valueOf();
        default:
            break;
    }
};